import lottie from "lottie-web";

export function initializeLottieAnimations(containers, errorPrefix = "Lottie") {
  const observers = [];
  const animations = [];
  const hoverHandlers = [];

  containers.forEach((container) => {
    const animationUrl = container.dataset.lottieUrl;
    if (!animationUrl) {
      return;
    }

    try {
      const animation = lottie.loadAnimation({
        container: container,
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: animationUrl,
      });

      container.lottieAnimation = animation;
      animations.push(animation);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && animation.currentFrame === 0) {
              animation.play();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 1.0 }
      );

      observer.observe(container);
      observers.push(observer);

      const handleMouseEnter = () => {
        animation.setDirection(-1);
        animation.play();
      };

      const handleMouseLeave = () => {
        animation.setDirection(1);
        animation.play();
      };

      container.addEventListener("mouseenter", handleMouseEnter);
      container.addEventListener("mouseleave", handleMouseLeave);
      hoverHandlers.push({ container, handleMouseEnter, handleMouseLeave });
    } catch (error) {
      console.error(`${errorPrefix}: Error loading Lottie animation`, error, animationUrl);
    }
  });

  return function cleanup() {
    observers.forEach((observer) => observer.disconnect());
    observers.length = 0;

    hoverHandlers.forEach(({ container, handleMouseEnter, handleMouseLeave }) => {
      container.removeEventListener("mouseenter", handleMouseEnter);
      container.removeEventListener("mouseleave", handleMouseLeave);
    });
    hoverHandlers.length = 0;

    animations.forEach((animation) => {
      if (animation) {
        animation.destroy();
      }
    });
    animations.length = 0;

    containers.forEach((container) => {
      if (container.lottieAnimation) {
        container.lottieAnimation = null;
      }
    });
  };
}

